import { FC } from "react";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";

const GapOverlapWidget: FC = () => (
    <div data-testid="compliance-connect__gap-overlap-widget">
        <QESWidget className="w-100">
            <QESWidgetHeader>
                <QESWidgetTitle>Gap Overlap</QESWidgetTitle>
            </QESWidgetHeader>
            <QESWidgetContent>
            </QESWidgetContent>
        </QESWidget>
    </div>
);

export default GapOverlapWidget;
